<script lang="ts" setup>
import { Heading } from "~/components/clarity-ui/Heading";
import { Paragraph } from "~/components/clarity-ui/Paragraph";

// todo: correct type needs to be defined
export interface AccountAccessDataProps {
  content: object; // Magnolia object
}

defineProps<AccountAccessDataProps>();

const emit = defineEmits(["delete-account"]);
</script>

<template>
  <Heading v-if="content?.headline.text" size="small" tag="h2">{{
    content?.headline.text
  }}</Heading>
  <Paragraph v-if="content?.text" class="mb-2">
    {{ content?.text }}
  </Paragraph>
  <button class="btn btn-ghost md:place-self-start" @click="emit('delete-account')">
    {{ content?.buttonLabel ?? "" }}
  </button>
</template>
